<template>
    <div class="form__listselect_table">
        <div class="container">
            <div class="form__listselect_table_table">
                <div class="columns is-variable">
                    <div class="column custom--overflow">
                        <table>
                            <list-table-head
                                :labels="newLabels"
                            />
                            <tbody>
                            <template
                                v-for="(item, index) in items"
                            >
                                <form-list-select-table-item
                                    ref="tableitem"
                                    :item="item"
                                    :key="index"
                                    @emit-unselected="unselectItem"
                                    @emit-selected="selectItem"
                                    :actions-visible="actionsVisible"
                                />
                            </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ListTableHead from '@/components/default/shared/ListTableHead'
import FormListSelectTableItem from '@/components/default/forms/FormListSelectTableItem'

export default {
  name: 'form-list-select-table',
  components: {
    FormListSelectTableItem,
    ListTableHead
  },
  data () {
    return {
      selected: []
    }
  },
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    actionsVisible: {
      type: Boolean,
      default: true
    },
    items: {
      type: [Array, Object]
    }
  },
  computed: {
    newLabels () {
      let labelsArr = this.labels
      if (this.actionsVisible) {
        if (labelsArr.indexOf('actions') === -1) labelsArr.push('actions')
      }
      return labelsArr
    }
  },
  methods: {
    selectItem: function (data) {
      this.selected = data
      // const tableitem = this.$refs.tableitem
      // for (let i = 0; i < tableitem.length; i++) {
      //   tableitem[i].unselect()
      // }
    },
    unselectItem: function (data) {
      this.selected = data
      // const tableitem = this.$refs.tableitem
      // for (let i = 0; i < tableitem.length; i++) {
      //   tableitem[i].unselect()
      // }
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formlistselecttable";
</style>
